import React from "react";

/**
 * @component ViewDayIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ViewDayIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ViewDayIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ViewDayIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path d="M9 6a1 1 0 011-1h9a1 1 0 110 2h-9a1 1 0 01-1-1zM9 12a1 1 0 011-1h9a1 1 0 110 2h-9a1 1 0 01-1-1zM9 18a1 1 0 011-1h9a1 1 0 110 2h-9a1 1 0 01-1-1zM5 4a1 1 0 011 1v14a1 1 0 11-2 0V5a1 1 0 011-1z" />
    </svg>
  )
);
ViewDayIcon.displayName = "ViewDayIcon";
export default ViewDayIcon;
